import UpdateThirdPartyForm from "./UpdateThirdPartyForm.container";

export default UpdateThirdPartyForm;
